jQuery( document ).ready(function() {

  if($('.herofullimg').length > 0) {

    $(".herofullimg_svg").click(function() {
        $('html,body').animate({
            scrollTop: $(".duolargeimgtxt").offset().top},
            'slow');
    });

     $('#homepage_slider').owlCarousel({
            loop: true,
            nav: false,
            items: 1,
            dots: false,
            autoplay:true,
            autoplayTimeout:7000,
            autoplayHoverPause:true
        });

      $('.owl-carousel').trigger('refresh.owl.carousel');

  }

});